import { render } from "./MyOrder.vue?vue&type=template&id=3c5be8df&scoped=true"
import script from "./MyOrder.vue?vue&type=script&lang=js"
export * from "./MyOrder.vue?vue&type=script&lang=js"

import "./MyOrder.vue?vue&type=style&index=0&id=3c5be8df&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5be8df"]])

export default __exports__